import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { WarrantyCheck } from '~/utils/warrantyCheck';

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export default function useWarranty({ serialNumber, itemInfo }) {
  const [isWarrantyVisible, setIsWarrantyVisible] = useState(false);

  const warrantyQuery = useQuery({
    queryKey: ['warranty', serialNumber],
    queryFn: () => WarrantyCheck(serialNumber, { data: itemInfo }),
    enabled: false,
    staleTime: ONE_DAY_MS,
    gcTime: ONE_DAY_MS,
    retry: 1,
  });

  useEffect(() => {
    setIsWarrantyVisible(false);
  }, [serialNumber]);

  const showWarranty = async () => {
    if (!serialNumber || !itemInfo?.serial_number) {
      return;
    }

    await warrantyQuery.refetch();
    setIsWarrantyVisible(true);
  };

  const closeWarranty = () => {
    setIsWarrantyVisible(false);
  };

  return {
    isWarrantyVisible,
    showWarranty,
    closeWarranty,
    warrantyCheck: warrantyQuery.data || [],
    warrantyLoading: warrantyQuery.isFetching,
    warrantyError: warrantyQuery.isError,
  };
}
